(function($){
    $(document).ready(function(){
        auto_hiding_top_bar('#masthead','.topbar-wrapper');
        $('section.banner img:not(.serviceIcon)').parallax('section.banner figure',6,-1)
        $('body.home .wp-block-cover .wp-block-cover__image-background').parallax('body.home .wp-block-cover',6,-1)

        $('.wp-block-cover.is-parralax .wp-block-cover__image-background').each(function(){
            $(this).parallax($(this).parent(),6,-1)
        })

        $('.menu-item-has-children > a').each(function(){
            if($(this).attr('href').includes('/services')){
                $(this).attr('href',$(this).parent().find('.sub-menu li:first-child a').attr('href'));
            }
        })

        $('.lang_select a').on('click',function(e){
            if($(this).attr('href').includes('?lang=en')){
                e.preventDefault();
                alert('Version anglaise en construction!')
            }
        });

        if($('#searchform #search').val() !== ''){
            toggleSearch()
        }
        $('#searchform').submit(toggleSearch)
        function toggleSearch(e = null){
            if(!$('#searchform').hasClass('develop') && $(window).width() > 768){
                if(e){
                    e.preventDefault();
                }
                $('#searchform input[type="text"]').focus();
                $('#searchform').addClass('develop');
                $('body').on('click.closesearch',function(e){
                    if(!$(e.target).attr('id') == "searchform" || $(e.target).parents('#searchform').length == 0 ){
                        $('body').off('click.closesearch');
                        $('#searchform').removeClass('develop');
                    }
                })
            }
        }
    })
    
})(jQuery);



function auto_hiding_top_bar(parent_selector,top_bar_selector){
    if($ == undefined){
        if(jQuery == undefined) {
            return;
        }
        $ = jQuery;
    }
    const parent = $(parent_selector);
    const top_bar = $(top_bar_selector);

    const logoAnim = __SVGATOR_PLAYER__.build({
        "root": "erx08xhtwec1",
        "animations": [{"duration":250,"direction":1,"iterations":1,"fill":1,"alternate":false,"elements":{"erx08xhtwec2":{"transform":{"data":{"t":{"x":-63.349609375,"y":-28.443359375}},"keys":{"o":[{"t":0,"v":{"x":63.349609375,"y":28.443359375,"type":"corner"}},{"t":250,"v":{"x":86.99718749500002,"y":28.520604325,"type":"corner"}}],"s":[{"t":0,"v":{"x":1,"y":1}},{"t":130,"v":{"x":1.0988275023828242,"y":1.1339365212372594}},{"t":250,"v":{"x":1.36,"y":1.36}}]}}},"erx08xhtwec6":{"transform":{"data":{"t":{"x":-27.85546875,"y":-28.443359375}},"keys":{"o":[{"t":0,"v":{"x":27.855468749999993,"y":28.443359375,"type":"corner"}},{"t":250,"v":{"x":13.927734379999993,"y":28.439999999999998,"type":"corner"}}],"s":[{"t":0,"v":{"x":1,"y":1}},{"t":250,"v":{"x":0.5,"y":0.5}}]}}},"erx08xhtwec12":{"transform":{"data":{"t":{"x":-70.849609375,"y":-20.7890625}},"keys":{"o":[{"t":0,"v":{"x":70.849609375,"y":20.7890625,"type":"corner"}},{"t":250,"v":{"x":36.294609375000086,"y":20.776866300000002,"type":"corner"}}]}}},"erx08xhtwec13":{"transform":{"data":{"t":{"x":-78.41015625,"y":-20.80078125}},"keys":{"o":[{"t":0,"v":{"x":78.41015625,"y":20.80078125,"type":"corner"}},{"t":250,"v":{"x":43.855156250000086,"y":20.788585050000002,"type":"corner"}}]}}},"erx08xhtwec14":{"transform":{"data":{"t":{"x":-87.083984375,"y":-20.7890625}},"keys":{"o":[{"t":0,"v":{"x":87.083984375,"y":20.7890625,"type":"corner"}},{"t":250,"v":{"x":52.528984375000064,"y":20.776866300000002,"type":"corner"}}]}}},"erx08xhtwec15":{"transform":{"data":{"t":{"x":-95.310546875,"y":-20.779296875}},"keys":{"o":[{"t":0,"v":{"x":95.310546875,"y":20.779296875,"type":"corner"}},{"t":250,"v":{"x":60.75554687500002,"y":20.767100675000002,"type":"corner"}}]}}},"erx08xhtwec16":{"transform":{"data":{"t":{"x":-102.720703125,"y":-20.779296875}},"keys":{"o":[{"t":0,"v":{"x":102.720703125,"y":20.779296875,"type":"corner"}},{"t":250,"v":{"x":68.16570312499994,"y":20.767100675000002,"type":"corner"}}]}}},"erx08xhtwec17":{"transform":{"data":{"t":{"x":-108.775390625,"y":-20.779296875}},"keys":{"o":[{"t":0,"v":{"x":108.775390625,"y":20.779296875,"type":"corner"}},{"t":250,"v":{"x":74.22039062499994,"y":20.767100675000002,"type":"corner"}}]}}},"erx08xhtwec18":{"transform":{"data":{"t":{"x":-115.671875,"y":-20.80078125}},"keys":{"o":[{"t":0,"v":{"x":115.671875,"y":20.80078125,"type":"corner"}},{"t":250,"v":{"x":81.11687499999994,"y":20.788585050000002,"type":"corner"}}]}}},"erx08xhtwec19":{"transform":{"data":{"t":{"x":-124.509765625,"y":-20.779296875}},"keys":{"o":[{"t":0,"v":{"x":124.509765625,"y":20.779296875,"type":"corner"}},{"t":250,"v":{"x":89.95476562499994,"y":20.767100675000002,"type":"corner"}}]}}},"erx08xhtwec21":{"transform":{"data":{"t":{"x":-76.240234375,"y":-32.826171875}},"keys":{"o":[{"t":0,"v":{"x":76.240234375,"y":32.826171875,"type":"corner"}},{"t":250,"v":{"x":41.685234375000086,"y":32.813975674999995,"type":"corner"}}]}}},"erx08xhtwec22":{"transform":{"data":{"t":{"x":-92.640625,"y":-33.005859375}},"keys":{"o":[{"t":0,"v":{"x":92.640625,"y":33.005859375,"type":"corner"}},{"t":250,"v":{"x":58.085625000000036,"y":32.993663174999995,"type":"corner"}}]}}},"erx08xhtwec23":{"transform":{"data":{"t":{"x":-105.01171875,"y":-33.005859375}},"keys":{"o":[{"t":0,"v":{"x":105.01171875,"y":33.005859375,"type":"corner"}},{"t":250,"v":{"x":70.45671874999994,"y":32.993663174999995,"type":"corner"}}]}}},"erx08xhtwec24":{"transform":{"data":{"t":{"x":-119.455078125,"y":-32.826171875}},"keys":{"o":[{"t":0,"v":{"x":119.455078125,"y":32.826171875,"type":"corner"}},{"t":250,"v":{"x":84.90007812499994,"y":32.813975674999995,"type":"corner"}}]}}}}}],
        "options": {
            "start": "load",
            "hover": "freeze",
            "click": "freeze",
            "scroll": 25,
            "font": "embed",
            "exportedIds": "unique", 
            "title": "logo_cvac"
        },
        "animationSettings": {
            "duration": 250,
            "direction": 1,
            "iterations": 1,
            "fill": 1,
            "alternate": false
        }
    })
    
    if(parent.length > 0 && top_bar.length > 0){

        let didScroll = false;
        let lastScrollTop = 0;
        const delta = 50;
        let isTop = true;

        ;
 

        if($(window).width() <= 980){
            logoAnim.speed = 250
            logoAnim.play()
            parent.addClass('scrolled');
        }

        setInterval(function() {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        $(window).scroll(function(event){
            didScroll = true;
        })

        function hasScrolled() {
            var scrolltop = $(this).scrollTop();


            if (Math.abs(lastScrollTop - scrolltop) <= delta){
                return;
            }

            if(scrolltop == 0 && !isTop && $(window).width() > 980){    
                logoAnim.speed = $(window).width() > 980 ? 1 : 250;
                isTop = !isTop
                parent.removeClass('scrolled');
                logoAnim._rollback()
            }else if(isTop){
                logoAnim.speed = $(window).width() > 980 ? 1 : 250;
                isTop = !isTop
                parent.addClass('scrolled');
                logoAnim.play()
            }

            // If current position > last position AND scrolled past navbar...
            if (scrolltop > lastScrollTop && scrolltop > top_bar.outerHeight()){ 
                // Scroll Down 
                parent.css('transform','translateY(-'+top_bar.outerHeight()+'px)');
            }else {  // Scroll Up
                parent.css('transform','translateY(0)');
            }
            lastScrollTop = scrolltop;
        }
    }
    
}